import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { DatePicker } from '@livable/saas-react-components';
import { DatePickerMonth } from '@livable/saas-react-components';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import MonthRangeDatePicker from 'src/components/general/MonthRangeDatePicker';
import useStyles from '../styles';
const DatePickerExample = "\nimport { DatePicker } from '@livable/saas-react-components';\n\n<DatePicker\n  value={new Date()}\n  onChange={func}\n  format={string}\n  label={string}\n  showMonthYearPicker={bool}\n  error={bool}\n  minDate={new Date()}\n  maxDate={new Date()}\n/>\n";
const NewRangeDatePickerExample = "\nimport RangeDatePicker from 'src/components/general/RangeDatePicker';\n\n<RangeDatePicker\n  disabled={bool}\n  label={string}\n  fromDate={new Date()}\n  toDate={new Date()}\n  handleDateChange={func}\n  format={string} // 'MM/dd/yy' - default\n/>\n";
const DatePickerMonthExample = "\nimport { DatePicker } from '@livable/saas-react-components';\n\n<DatePicker\n  format=\"MMMM yyyy\"\n  showMonthYearPicker={true}\n/>\n";
const DatePickerMonthWithControlsExample = "\nimport { DatePickerMonth } from '@livable/saas-react-components';\n\n<DatePickerMonth\n  showTitle={bool}\n  date={new Date()}\n  setDate={func}\n/>\n";
const NewMonthRangeDatePickerExample = "\nimport MonthRangeDatePicker from 'src/components/general/MonthRangeDatePicker';\n\n<MonthRangeDatePicker\n  disabled={bool}\n  label={string}\n  fromDate={new Date()}\n  toDate={new Date()}\n  handleDateChange={func}\n  format={string} // 'MMM yyyy' - default\n/>\n";
export default function LvDatePickers() {
  const classes = useStyles();
  const _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  const _useState3 = useState(new Date()),
    _useState4 = _slicedToArray(_useState3, 2),
    choosenMonth = _useState4[0],
    setChoosenMonth = _useState4[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Datepickers"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement("span", null, "Datepickers variations "), /*#__PURE__*/React.createElement(Link, {
    href: "https://reactdatepicker.com/",
    target: "_blank"
  }, "(library)")), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Single date picker"), /*#__PURE__*/React.createElement("div", {
    className: classes.datePickerWrapper
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: startDate,
    onChange: setStartDate,
    format: "MM/dd/yy",
    label: "Pick date"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, DatePickerExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Dates range picker"), /*#__PURE__*/React.createElement(RangeDatePicker, {
    label: "Pick dates range"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, NewRangeDatePickerExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Single month picker"), /*#__PURE__*/React.createElement("div", {
    className: classes.datePickerWrapper
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: choosenMonth,
    onChange: setChoosenMonth,
    format: "MMMM yyyy",
    showMonthYearPicker: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, DatePickerMonthExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Single month picker with external controls"), /*#__PURE__*/React.createElement(DatePickerMonth, null), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, DatePickerMonthWithControlsExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Months range picker"), /*#__PURE__*/React.createElement(MonthRangeDatePicker, null), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, NewMonthRangeDatePickerExample))))));
}